<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
            {{title}}
        </div>
        </div>
        <div class="m-panel-body">
            <a-row style="height: 100%">
                <a-col :span="24" style="height: calc(100% - 120px)">
                    <a-row style="height: 96px" class="water-use-total">
                    </a-row>
                    <a-row style="height: calc(100% - 96px)">
                        <a-col :span="12" style="text-align: center;">
                            <div class="m-total flex-center">
                                <!-- <div class="circle flex-center">
                                    <i class="iconfont iconbj" :style="{color: useList.userCountNoFlow>0?'red': '#fff'}"></i>
                                    <div class="flex-center" style="width: 100%;height: 100%;position: absolute" v-if="useList.userCountNoFlow>0">
                                        <div class="circle-item circle-item1"></div>
                                        <div class="circle-item circle-item2"></div>
                                        <div class="circle-item circle-item3"></div>
                                    </div>
                                </div> -->
                                <div class="" style="width: calc(100% - 40px)">
                                    
                                    <div class="total-title flex-center">{{ $t('零流量用水') }}</div>
                                    <div class="total-sum flex-center">
                                        <span  class="font-30 ds-digital-bold" style="cursor:pointer" @click="skipPage(0)">
                                            <animated-integer :value="useList.userCountNoFlow"></animated-integer>
                                        </span>
                                        <span class="unit">{{ $t('处') }}</span>
                                    </div>
                                </div>
                            </div>
                        </a-col>
                        <a-col :span="12" style="text-align: center">
                            <div class="m-total">
                            <div class="total-title flex-center">{{ $t('本年累计用水量') }}</div>
                            <div class="total-sum flex-center">
                                <span class="font-30 ds-digital-bold">
                                    <animated-integer :value="useList.waterUseYear"></animated-integer>
                                </span>
                                <span class="unit">m³</span>
                            </div>
                            </div>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="24" style="height:100px">
                    <a-row style="height: 33.33%;justify-content: flex-start;" class="flex flex-center water-use-type">
                        <a-col :span="6" style="text-align: left">
                            <span class="total-type-title">{{ $t('近七日') }}</span>
                        </a-col>
                        <a-col :span="18" style="text-align: end">
                            <span class="ds-digital-bold font-24">
                                <animated-integer :value="useList.waterUseLatest7Days"></animated-integer>
                            </span>
                            <span class="unit">m³</span>
                        </a-col>
                        <!--
                        <a-col :span="9" style="text-align: center">
                            <span class="ds-digital-bold font-24">
                                <animated-integer :value="useList.waterUseYesterdayPercent"></animated-integer>
                            </span>
                            <span class="unit">%</span>
                        </a-col>
                        <a-col :span="3" style="text-align: center">
                            <i v-if="useList.waterUseYesterdayPercent>0" class="iconfont iconjiantou-up"></i>
                            <i v-else class="iconfont iconjiantou-down"></i>
                        </a-col>
                        -->
                    </a-row>
                    <a-row style="height: 33.33%;justify-content: flex-start;" class="flex flex-center water-use-type">
                        <a-col :span="6" style="text-align: left">
                            <span class="total-type-title">{{ $t('本月') }}</span>
                        </a-col>
                        <a-col :span="18" style="text-align: end">
                            <span class="ds-digital-bold font-24">
                                <animated-integer :value="useList.waterUseCurMonth"></animated-integer>
                            </span>
                            <span class="unit">m³</span>
                        </a-col>
                    </a-row>
                    <a-row style="height: 33.33%;justify-content: flex-start;" class="flex flex-center water-use-type">
                        <a-col :span="6" style="text-align: left">
                            <span class="total-type-title">{{ $t('上月') }}</span>
                        </a-col>
                        <a-col :span="18" style="text-align: end">
                            <span class="ds-digital-bold font-24">
                                <animated-integer :value="useList.waterUseLastMonth"></animated-integer>
                            </span>
                            <span class="unit">m³</span>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
        </div>
    </div>
</template>
<script>
import animatedInteger from '@/components/maComponents/animated-integer';
import { putAction } from '@/api/manage'
export default {
    components:{
        animatedInteger
    },
    props: {
            titleImage: {
            type: String,
            default: ''
        },
    },
    data() {
        return{
            url: {
                list: '/jeecg-charge/meter/waterAnalysis/waterUse'
            },
            title: this.$t('用水量分析'),
            useList: {
                userCountNoFlow: 0,
                waterUseYear: 0,
                waterUseYesterday: 0,
                waterUseYesterdayPercent: 0,
                waterUseCurMonth: 0,
                waterUseLastMonth: 0
            }
        }
    },
    mounted() {
        
    },
    methods: {
        init() {
            this.useList = this.$options.data.call(this).useList
            this.querywaterUseTotal()
        },
        querywaterUseTotal() {
            putAction(this.url.list, {}).then((res) => {
                if(res.success){
                    this.useList = res.result
                    this.useList.waterUseYesterdayPercent = Number(res.result.waterUseYesterdayPercent)
                }
            })
        },
        skipPage(flag) {
            if(flag == 0) {
                this.$router.push({ path: "/meterAlarmManagement/trafficQueryList" })
            }
        }
    }
}
</script>
<style scoped>
.iconjiantou-up{
    color: #D0021B;
}
.iconjiantou-down{
    color:#22C1B9;
}
.iconbj{
    color: red;
    font-size: 20px;
    float: left;
}
.total-sum {
    display: flex;
    align-items: center;
}
.circle{
    position: relative;
    width: 40px;
    height: 40px;
}
.circle-item{
    position: absolute;
    width: 20px;
    height: 20px;
    background: red;
    border-radius: 50%;
    
}
.circle-item1{
    animation: circleAnima 1.2s linear infinite;
}
.circle-item2{
    animation: circleAnima 1.2s linear infinite;
    animation-delay: 0.5s;
}
.circle-item3{
    animation: circleAnima 1.2s linear infinite;
    animation-delay: 1.2s;
}
@keyframes circleAnima {
      0% {
        opacity: 0.6;
        transform: scale(1);
      }
      50% {
        opacity: 0.4;
        transform: scale(1.5);
      }
      100% {
        opacity: 0.3;
        transform: scale(2);
      }
    }
    .water-use-type {
        background: url('~@/assets/images/water-use-type.png') no-repeat;
        background-size: 100% 100%;
        margin-top: 5px;
        padding-left:15px;
        padding-right:24px;
    }
    .water-use-total{
        /* margin-top: 40px; */
        background: url('~@/assets/images/water-use-total.png') no-repeat;
        background-size: 100% 100%;
    }
    .index-main .total-sum{
      margin-top: 10px !important;
    }
</style>